import { object, string, array } from "yup"
import { ID } from "../yup.common"

const companyModel = object({
  id: ID,
  name: string().min(3).max(60).required().label("Company Name"),
  codename: string().label("Company Code"),
  departments: array(object()).label("Departments"),
  displayName: string().min(3).max(15).label("Company Tag"),
})

export default companyModel
